import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/survey';
import * as surveyPageActions from '../actions/survey';
import { Log } from 'ng2-logger';
import { SurveyService } from '../../api/survey-page-service';
import Translator from '../../core/i18n';
import { Notification } from '../../components/notification/main';
import * as coreActions from '../actions/core';
import { IGetAddSurvey, IGetEditSurveyInfo, IResponseSurvey, IUpdateSurveyGet } from '../../models/action/survey';
import { IActionRequestDate } from '../../models/core/action-request';
import { CacheService } from '../../core/cacheService';

const T = Translator.create();
const _logger = Log.create('Survey Saga');
const _surveyService = new SurveyService();
const _cacheService = new CacheService();

function* setAddSurveyActivity(params: IGetAddSurvey) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        yield _surveyService.RequestAddSurveyActivityAsync(params.surveyData)
            .then((response: Response) => {
                return response;
            }).then((response: Response) => {
                if (response.status !== 200) {
                    isError = true;
                }
                return response.json();
            }).then((responseData: any) => {
                if (isError) {
                    errorList = responseData;
                } else {
                    pageData = responseData;
                }
            });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_api_gen_add_activity_error'), 'topRight');
            if (params.spinnerId) {
                yield put(coreActions.setSpinner(params.spinnerId, 'set'));
            }
            if (params.callback) {
                params.callback(null);
            }
        }

        if (!isError) {
            yield put(coreActions.newNotification(T.t(!params.surveyData.isUpdate ? 'r_add_activity_succesful_notification' : 'r_update_activity_succesful_notification'), '', '', 'topRight', 'success'));
            const redirectPageParams: any = {
                submitValues: params.surveyData,
                activityId: params.surveyData.projectActivityId ? params.surveyData.projectActivityId : params.surveyData.activityId ? params.surveyData.activityId : pageData,
                isResponded: params.surveyData.surveyInfo ? params.surveyData.surveyInfo.isResponded : 0,
                termWeekId:
                    params.surveyData.termWeekIds && params.surveyData.termWeekIds[0] !== '0'
                        ? params.surveyData.termWeekIds[0]
                        : params.surveyData.termWeekIds[1]
            };
            if (params.callback) {
                params.callback(redirectPageParams);
            }
        }
    } catch (error: any) {
        yield put(coreActions.newNotification(T.t(params.surveyData.isUpdate ? 'r_api_gen_update_activity_error' : 'r_api_gen_add_activity_error') + ' / ' + error, '', '', 'topRight', 'error'));
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        if (params.callback) {
            params.callback(null);
        }
    }
}

function* setSurveyActivity(params: IUpdateSurveyGet) {
    let isError: boolean = false;
    let errorList: any;
    let pageData: any;
    try {
        yield _surveyService.RequestGetUpdateSurveyActivity({ ...params, take: 20, skip: 0 })
            .then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_request_error_on_activity_get'), 'topRight');
        } else {
            yield put(surveyPageActions.addSurveySetAction(pageData, false, params.spinnerId ? params.spinnerId : '', 'set'));
        }
    } catch (error: any) {
        yield put(coreActions.newNotification(T.t('r_request_error_on_activity_get') + ' / ' + error, '', '', 'topRight', 'error'));
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    }
}

function* setDeleteSurveyActivity(params: any) {
    let isError: boolean = false;
    let errorList: any;
    let pageData: any;
    try {
        yield _surveyService.RequestDeleteSurveyActivityAsync(params).then((response: Response) => {
            return response;
        }).then((response: Response) => {
            if (response.status !== 200) {
                isError = true;
            }
            return response.json();
        }).then((responseData: any) => {
            if (isError) {
                errorList = responseData;
            } else {
                pageData = responseData;
            }
        });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_api_survey_delete_problem_message'), 'topRight');
            if (params.spinnerId) {
                yield put(coreActions.setSpinner(params.spinnerId, 'set'));
            }
        }

        if (!isError) {
            yield put(surveyPageActions.addSurveySetAction(null, true));
        }
    } catch (error: any) {
        yield put(coreActions.newNotification(T.t('r_api_survey_delete_problem_message') + ' / ' + error, '', '', 'topRight', 'error'));
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    }
}

function* getEditSurveyInfo(params: IGetEditSurveyInfo) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        yield _surveyService.RequestEditSurveyInfoAsync({
            activityId: params.surveyData.activityId,
            surveyInfoId: params.surveyData.surveyInfo.surveyInfoId,
            name: params.surveyInfo.name ? params.surveyInfo.name : params.surveyData.surveyInfo.name,
            questionList: params.surveyInfo.questionList,
            courseId: params.surveyData.courseId
        })
            .then((response: Response) => {
                return response;
            }).then((response: Response) => {
                if (response.status !== 200) {
                    isError = true;
                }
                return response.json();
            }).then((responseData: any) => {
                if (isError) {
                    errorList = responseData;
                } else {
                    pageData = responseData;
                }
            });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_update_question_error'), 'topRight');
            if (params.spinnerId) {
                yield put(coreActions.setSpinner(params.spinnerId, 'set'));
            }
        }

        if (!isError) {
            yield put(coreActions.newNotification(T.t(!params.surveyData.isUpdate ? 'r_add_survey_succesful_notification' : 'r_update_survey_succesful_notification'), '', '', 'topRight', 'success'));
            const redirectPageParams: any = {
                submitValues: params.surveyData,
                activityId: params.surveyData.projectActivityId ? params.surveyData.projectActivityId : params.surveyData.activityId ? params.surveyData.activityId : pageData,

                termWeekId:
                    params.surveyData.termWeekIds && params.surveyData.termWeekIds[0] !== '0'
                        ? params.surveyData.termWeekIds[0]
                        : params.surveyData.termWeekIds[1]
            };
            if (params.callback) {
                params.callback(redirectPageParams);
            }
        }
    } catch (error: any) {
        yield put(coreActions.newNotification(T.t(params.surveyData.isUpdate ? 'r_update_question_error' : 'r_add_question_error') + ' / ' + error, '', '', 'topRight', 'error'));
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    }
}

function* responseSurvey(params: IResponseSurvey) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {

        yield _surveyService.RequestResponseSurveyAsync({ ...params })
            .then((response: Response) => {
                return response;
            }).then((response: Response) => {
                if (response.status !== 200) {
                    isError = true;
                }
                return response.json();
            }).then((responseData: any) => {
                if (isError) {
                    errorList = responseData;
                } else {
                    pageData = responseData;
                }
            });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_update_question_error'), 'topRight');
            if (params.spinnerId) {
                yield put(coreActions.setSpinner(params.spinnerId, 'set'));
            }
        }

        if (!isError) {
            if (params.callback) {
                params.callback(pageData);
            }
        }


    } catch (error: any) {
        yield put(coreActions.newNotification(T.t('Cevaplarınız kaydedilirken bir hata oluştu.') + ' / ' + error, '', '', 'topRight', 'error'));
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    }
}

//#region "Survey Saga"
function* setSurveysData(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield _surveyService
            .RequestGetSurveyListAsync(params)
            .then((response: Response) => {
                return response;
            })
            .then((response: Response) => {
                if (response.status !== 200) {
                    isError = true;
                }
                return response.json();
            })
            .then((responseData: any) => {
                if (isError) {
                    errorList = responseData;
                }
                return responseData;
            });

        if (isError) {
            errorList
                ? Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                })
                : yield put(coreActions.newNotification(T.t('r_get_survey_list_error_message'), '', '', 'topRight', 'error'));
        }

        if (!isError) {
            yield put(surveyPageActions.setSurveysAction(pageData, true, '4', params.spinnerId, 'set', params.take, params.skip, params.isHomePageAnnouncement));
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

    } catch (error: any) {
        yield put(coreActions.newNotification(T.t('r_get_survey_list_error_message'), '', '', 'topRight', 'error'));
    }
}

function* setLoginSurveyDataById(params: any): any {
    const _surveyService = new SurveyService();
    let isError = false;
    let errorList: any;
    try {
        yield put(surveyPageActions.SetLoginSurveyByIdAction(null, false));
        const requestReturn = yield _surveyService.RequestGetSelectedSurveyAsync(params).then((response: Response) => {
            return response;
        }).then((response: Response) => {
            if (response.status !== 200) {
                isError = true;
            }

            return response.json();
        }).then((responseData: any) => {
            if (isError) {
                errorList = responseData;
            } else {
                return responseData;
            }
        });

        if (isError) {
            (errorList) ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_course_page_lessonPage_surveys_error_message'), 'topRight');
        }

        if (!isError) {
            yield put(surveyPageActions.SetLoginSurveyByIdAction(requestReturn, true, params.spinnerId, 'set'));
        }
    } catch (error: any) {
        // catch error!
        yield put(coreActions.newNotification(T.t('r_course_page_lessonPage_surveys_error_message'), '', '', 'topRight', 'error'));
    }
}

function* setGeneralSurveyDataById(params: any): any {

    const _surveyService = new SurveyService();
    let isError = false;
    let errorList: any;
    try {
        const requestReturn = yield _surveyService.RequestGetGeneralSurveyAsync(params).then(
            (response: Response) => {
                return response;
            }).then((response: Response) => {
                if (response.status !== 200) {
                    isError = true;
                }
                return response.json();
            }).then((responseData: any) => {
                if (isError) {
                    errorList = responseData;
                } else {
                    return responseData;
                }
            });

        if (isError) {
            (errorList) ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_course_page_lessonPage_surveys_error_message'), 'topRight');
        }

        if (!isError) {
            yield put(surveyPageActions.SetGeneralSurveyByIdAction(requestReturn, true, params.spinnerId, 'set'));
        }
    } catch (error: any) {
        // catch error!
        yield put(coreActions.newNotification(T.t('r_course_page_lessonPage_surveys_error_message'), '', '', 'topRight', 'error'));
    }
}

export function* watchGetSurveysData() {
    yield takeEvery(constants.actions.GET_SURVEY_LIST, setSurveysData);
    return null;
}

export function* watchGetAddSurveyData() {
    yield takeEvery(constants.actions.ADD_SURVEY_ACTIVITY, setAddSurveyActivity);
    return null;
}

export function* watchGetDeleteSurveyData() {
    yield takeEvery(constants.actions.DELETE_SURVEY_ACTIVITY, setDeleteSurveyActivity);
    return null;
}

export function* watchUpdateSurveyData() {
    yield takeEvery(constants.actions.ADD_SURVEY_UPDATE_ACTIVITY, setSurveyActivity);
    return null;
}

export function* watchGetEditSurveyInfo() {
    yield takeEvery(constants.actions.GET_EDIT_SURVEY_INFO, getEditSurveyInfo);
    return null;
}

export function* watchResponseSurvey() {
    yield takeEvery(constants.actions.RESPONSE_SURVEY, responseSurvey);
    return null;
}

export function* watchLoginSurveyDataById() {
    yield takeEvery(constants.actions.GET_SELECTED_LOGIN_SURVEY, setLoginSurveyDataById);
}

export function* watchGetGeneralSurveyById() {
    yield takeEvery(constants.actions.GET_SELECTED_GENERAL_SURVEY, setGeneralSurveyDataById);
    return null;
}

//#endregion "Add Assignment Activity End Saga"

export function* SurveySagas() {
    yield all([
        watchLoginSurveyDataById(),
        watchGetSurveysData(),
        watchGetAddSurveyData(),
        watchGetDeleteSurveyData(),
        watchUpdateSurveyData(),
        watchGetEditSurveyInfo(),
        watchResponseSurvey(),
        watchGetGeneralSurveyById()
    ]);
}
